/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Voice_FrenchInputs */

const en_onboarding_voice_french = /** @type {(inputs: Onboarding_Voice_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`French`)
};

const es_onboarding_voice_french = /** @type {(inputs: Onboarding_Voice_FrenchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Francés`)
};

/**
* | output |
* | --- |
* | "French" |
*
* @param {Onboarding_Voice_FrenchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_voice_french = /** @type {((inputs?: Onboarding_Voice_FrenchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Voice_FrenchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_voice_french(inputs)
	return en_onboarding_voice_french(inputs)
});